import { GeoData, GeoGeoableData } from '@/common/types/geoGeoable'
import { ProductCategoryData } from '@/common/types/productCategory.type'
import { ProductData } from '@/features/products/types/product'

export enum CompanyContractConsumptionControlledBy {
  Currency = 'currency',
  Quantity = 'quantity',
}

export type CompanyContractType = {
  id: string
  bill_by: string
  bill_grouping_mode: string
  bill_sub_grouping_mode: string
  closing_to_due_in_days: number
  cnpj_for_fiscal_document: string
  contract_equipment_categories: {
    id: string
    equipment_category: {
      id: string
      description: string
      display_name: string
      field_for_display: string
      required_field_names: string[]
      unit_for_consumption: string
    }
    quantity: number
  }[]
  contract_fees: {
    id: string
    fee_template: {
      id: string
      applicable_entity: string
      calculate_as: string
      display_name: string
      updated_at: string
    }
    main_fee: boolean
    value: string
  }[]
  contract_product_categories: {
    id: string
    contract_product_category_products: {
      id: string
      contract_product_category_product_prices: {
        id: string
        geo: GeoData
        value: string
      }[]
      global_value_in_currency: string
      global_value_in_unit_for_consumption: string
      price_rule: string
      product: ProductData
    }[]
    global_value_in_currency: string
    global_value_in_unit_for_consumption: string
    product_category: ProductCategoryData
  }[]
  cycle: string
  cycle_start_day: number
  cycle_fixed_interval: number
  default_fuel_price_rule: string
  due_to_suspension_in_days: number
  duration_in_months: number
  file: {
    id: string
    attachment_id: string
    content_type: string
    url: string
  }
  fiscal_document_requirement: string
  geo_geoables: GeoGeoableData[]
  global_value: string
  granted_credit: string
  in_effect_since: string
  in_effect_until: string
  last_review: any
  payment_method: string
  payment_modality: string
  protocol_number: string
  state: string
  fiscal_document_consumer?: string
  require_product_credit_quota: boolean
  consumption_controlled_by: CompanyContractConsumptionControlledBy;
}

export type CompanyContractResponse = {
  data: {
    data: CompanyContractType
  }
}
